import React from 'react'
import { SvgIcon, SvgIconProps } from '@hermes/web-components'

const defaultColor = '#2C3341'

const SuccessIcon = ({ color, ...props }: SvgIconProps) => (
  <SvgIcon width="24" height="25" viewBox="0 0 24 25" {...props}>
    <path
      d="M22 11.1617V12.0817C21.9988 14.2381 21.3005 16.3363 20.0093 18.0635C18.7182 19.7906 16.9033 21.0541 14.8354 21.6656C12.7674 22.277 10.5573 22.2036 8.53447 21.4562C6.51168 20.7089 4.78465 19.3278 3.61096 17.5187C2.43727 15.7097 1.87979 13.5697 2.02168 11.418C2.16356 9.26622 2.99721 7.21798 4.39828 5.57872C5.79935 3.93947 7.69279 2.79703 9.79619 2.3218C11.8996 1.84656 14.1003 2.06399 16.07 2.94165"
      stroke={color || defaultColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
    <path
      d="M22 4.08167L12 14.0917L9 11.0917"
      stroke={color || defaultColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
  </SvgIcon>
)

export default SuccessIcon
